import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../paymentMethodsActions';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import PaymentMethodForm from './PaymentMethodForm';

const Transition = (props) => <Slide direction="up" {...props} />;

const styles = () => ({
  root: {
    width: '100%',
    // maxWidth: 786,
    margin: 'auto',
    margin: 0,
  },
  paper: {
    margin: 0,
    width: '100%',
    boxShadow: 'none',
  },
  paper1: {
    margin: 0,
    width: '100%',
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
});

let PaymentMethodFormContainer = ({
  paymentMethodFormIsVisible,
  hidePaymentMethodForm,
  createPaymentMethod,
  requestingCreatePaymentMethod,
  classes,
  noDialogBackground,
  appSource,
  errorMessage,
  clearErrorMessage,
}) => {
  const handleCancel = () => {
    clearErrorMessage();
    hidePaymentMethodForm();
  };
  

  return (
    <Dialog
      open={paymentMethodFormIsVisible}
      onClose={hidePaymentMethodForm}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      TransitionComponent={Transition}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      classes={classes.root}
      BackdropProps={{
        classes: {
          root: noDialogBackground && classes.backdrop,
        },
      }}
      PaperProps={{
        classes: { root: noDialogBackground ? classes.paper : classes.paper1 },
      }}
      aria-labelledby="create-payment-method"
      overlayStyle={{ backgroundColor: 'transparent' }}
      scroll="body"
    >
      <PaymentMethodForm
       hasError={errorMessage && errorMessage.message}
        handleCancel={handleCancel}
        handleSubmit={createPaymentMethod}
        isRequesting={requestingCreatePaymentMethod}
        appSource={appSource}
        errorMessage={errorMessage}
        clearErrorMessage={clearErrorMessage}
      />
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  errorMessage: state.paymentMethodsReducer.errorMessage,
  requestingCreatePaymentMethod:
    state.paymentMethodsReducer.requestingCreatePaymentMethod,
  paymentMethodFormIsVisible:
    state.paymentMethodsReducer.paymentMethodFormIsVisible,
  noDialogBackground: state.paymentMethodsReducer.noDialogBackground,
  appSource: state.authReducer.appConfig,
});

export default withStyles(styles)(
  connect(mapStateToProps, actions)(PaymentMethodFormContainer)
);
